import axiosInstance from '../AxiosInstance';

export function listUsers(params) {
    return axiosInstance.get('/users', { params });
}

export function listDirectoryUsers(params) {
    return axiosInstance.get('/users/directory', { params });
}

export function getDirectoryUser(userId, params) {
    return axiosInstance.get(`/users/directory/${userId}`, { params });
}

export function createBusinessUser(payload) {
    return axiosInstance.post('/business-users', payload);
}
